import React, { useMemo } from 'react';
import { useSeasonalTheme } from '../contexts/SeasonalThemeContext';

/**
 * Boîte cadeau 3D Noir & Or avec ruban satiné doré et éclats lumineux (Black Friday)
 */
const BlackFridayGiftBox = ({ className = '', flip = false }) => (
    <div className={`bf-gift-box-wrapper ${className}`} style={flip ? { transform: 'scaleX(-1)' } : undefined}>
        <svg viewBox="0 0 220 220" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
            <defs>
                {/* Dégradés Or Métallique */}
                <linearGradient id="bfGoldGrad1" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" stopColor="#fef08a" />
                    <stop offset="30%" stopColor="#eab308" />
                    <stop offset="65%" stopColor="#a16207" />
                    <stop offset="100%" stopColor="#fde047" />
                </linearGradient>
                <linearGradient id="bfGoldGrad2" x1="0%" y1="100%" x2="100%" y2="0%">
                    <stop offset="0%" stopColor="#713f12" />
                    <stop offset="45%" stopColor="#ca8a04" />
                    <stop offset="75%" stopColor="#fef08a" />
                    <stop offset="100%" stopColor="#eab308" />
                </linearGradient>
                <linearGradient id="bfGoldBright" x1="0%" y1="0%" x2="0%" y2="100%">
                    <stop offset="0%" stopColor="#ffffff" />
                    <stop offset="35%" stopColor="#fef08a" />
                    <stop offset="100%" stopColor="#ca8a04" />
                </linearGradient>

                {/* Dégradés Boîte Noire Mat 3D */}
                <linearGradient id="bfBoxLeft" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" stopColor="#2d2d35" />
                    <stop offset="100%" stopColor="#141418" />
                </linearGradient>
                <linearGradient id="bfBoxRight" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" stopColor="#1c1c22" />
                    <stop offset="100%" stopColor="#09090c" />
                </linearGradient>
                <linearGradient id="bfBoxTop" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" stopColor="#383842" />
                    <stop offset="100%" stopColor="#1f1f26" />
                </linearGradient>

                {/* Halo Doré Arrière-plan */}
                <radialGradient id="bfGiftGlow" cx="50%" cy="55%" r="50%">
                    <stop offset="0%" stopColor="rgba(234, 179, 8, 0.42)" />
                    <stop offset="55%" stopColor="rgba(234, 179, 8, 0.12)" />
                    <stop offset="100%" stopColor="rgba(234, 179, 8, 0)" />
                </radialGradient>
            </defs>

            {/* Halo lumineux et rayons d'éclats dorés */}
            <circle cx="110" cy="120" r="95" fill="url(#bfGiftGlow)" />
            <g stroke="url(#bfGoldGrad1)" strokeWidth="1.2" opacity="0.65">
                <line x1="110" y1="120" x2="25" y2="35" strokeDasharray="3 4" />
                <line x1="110" y1="120" x2="65" y2="15" strokeDasharray="2 5" />
                <line x1="110" y1="120" x2="155" y2="20" strokeDasharray="4 4" />
                <line x1="110" y1="120" x2="195" y2="55" strokeDasharray="2 4" />
                <line x1="110" y1="120" x2="18" y2="95" strokeDasharray="3 5" />
            </g>

            {/* Confettis et étincelles autour du cadeau */}
            <polygon points="38,48 45,42 49,50 42,55" fill="url(#bfGoldGrad1)" />
            <polygon points="75,24 83,20 85,27 77,30" fill="#fde047" opacity="0.9" />
            <polygon points="152,32 160,28 164,36 155,39" fill="url(#bfGoldGrad1)" />
            <polygon points="182,76 190,71 193,78 184,82" fill="#eab308" />
            <polygon points="22,82 28,77 31,84 24,88" fill="#fef08a" />
            <circle cx="56" cy="36" r="2.5" fill="#fef08a" />
            <circle cx="135" cy="25" r="2" fill="#fde047" />
            <circle cx="172" cy="52" r="3" fill="#fef08a" />
            <circle cx="30" cy="62" r="2" fill="#eab308" />

            {/* Étoiles scintillantes 4 branches */}
            <path d="M48,22 L50,29 L57,31 L50,33 L48,40 L46,33 L39,31 L46,29 Z" fill="#fef08a" />
            <path d="M168,36 L169.5,41 L174.5,42.5 L169.5,44 L168,49 L166.5,44 L161.5,42.5 L166.5,41 Z" fill="#ffffff" />

            {/* Groupe incliné de la boîte cadeau 3D */}
            <g transform="translate(10, 8) rotate(-9 105 130)">
                {/* Ombre portée au sol */}
                <ellipse cx="105" cy="192" rx="64" ry="14" fill="rgba(0,0,0,0.75)" />

                {/* Corps de la boîte - Face Gauche */}
                <polygon points="46,112 105,138 105,192 52,165" fill="url(#bfBoxLeft)" stroke="#3f3f48" strokeWidth="0.6" />
                {/* Corps de la boîte - Face Droite */}
                <polygon points="105,138 164,110 157,164 105,192" fill="url(#bfBoxRight)" stroke="#27272f" strokeWidth="0.6" />

                {/* Ruban vertical doré - Face Gauche */}
                <polygon points="69,122 83,128 84,181 71,175" fill="url(#bfGoldGrad1)" />
                {/* Ruban vertical doré - Face Droite */}
                <polygon points="127,127 141,121 136,174 124,180" fill="url(#bfGoldGrad2)" />

                {/* Ombre sous le couvercle */}
                <polygon points="44,111 105,139 166,109 165,115 105,144 45,116" fill="rgba(0,0,0,0.65)" />

                {/* Couvercle - Dessus */}
                <polygon points="40,95 105,70 170,93 105,122" fill="url(#bfBoxTop)" stroke="#4a4a55" strokeWidth="0.7" />
                {/* Couvercle - Rebord Gauche */}
                <polygon points="40,95 105,122 105,138 42,110" fill="url(#bfBoxLeft)" stroke="#383842" strokeWidth="0.6" />
                {/* Couvercle - Rebord Droit */}
                <polygon points="105,122 170,93 168,109 105,138" fill="url(#bfBoxRight)" stroke="#27272e" strokeWidth="0.6" />

                {/* Ruban sur le dessus du couvercle (Croix dorée) */}
                <polygon points="68,84 82,79 143,105 129,111" fill="url(#bfGoldGrad1)" />
                <polygon points="128,78 142,84 82,112 68,105" fill="url(#bfGoldGrad2)" />

                {/* Ruban sur les rebords du couvercle */}
                <polygon points="68,105 82,112 82,128 68,122" fill="url(#bfGoldGrad1)" />
                <polygon points="129,111 143,105 142,121 128,127" fill="url(#bfGoldGrad2)" />

                {/* Pans de ruban doré retombant sur le devant */}
                <path d="M102,94 Q85,112 76,134 L88,136 Q96,115 105,96 Z" fill="url(#bfGoldGrad1)" />
                <path d="M108,94 Q122,112 132,131 L120,135 Q112,115 105,96 Z" fill="url(#bfGoldGrad2)" />

                {/* Grand Nœud 3D Doré Satiné sur le dessus */}
                {/* Boucle arrière gauche */}
                <path d="M105,92 C82,66 56,74 68,92 C76,100 94,96 105,92 Z" fill="url(#bfGoldGrad2)" stroke="#fef08a" strokeWidth="0.5" />
                {/* Boucle arrière droite */}
                <path d="M105,92 C128,64 154,72 142,90 C134,98 116,95 105,92 Z" fill="url(#bfGoldGrad2)" stroke="#fef08a" strokeWidth="0.5" />
                {/* Boucle avant gauche */}
                <path d="M105,94 C78,76 62,92 78,103 C88,109 98,100 105,94 Z" fill="url(#bfGoldGrad1)" stroke="#fef9c3" strokeWidth="0.7" />
                {/* Boucle avant droite */}
                <path d="M105,94 C132,75 148,91 132,102 C122,108 112,100 105,94 Z" fill="url(#bfGoldGrad1)" stroke="#fef9c3" strokeWidth="0.7" />
                {/* Cœur central du nœud */}
                <ellipse cx="105" cy="93" rx="9" ry="7" fill="url(#bfGoldBright)" stroke="#a16207" strokeWidth="0.8" />
            </g>
        </svg>
    </div>
);

/**
 * Grappe de ballons 3D à droite (arrière-plan derrière les cartes vitrées)
 */
const BlackFridayBalloonsRight = () => (
    <div className="bf-balloons-right">
        <svg viewBox="0 0 260 420" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
            <defs>
                {/* Ballon Noir Brillant 3D */}
                <radialGradient id="bfBalloonBlack" cx="35%" cy="30%" r="65%">
                    <stop offset="0%" stopColor="#6b7280" />
                    <stop offset="18%" stopColor="#374151" />
                    <stop offset="55%" stopColor="#111827" />
                    <stop offset="100%" stopColor="#030712" />
                </radialGradient>
                {/* Ballon Or Métallique 3D */}
                <radialGradient id="bfBalloonGold" cx="35%" cy="28%" r="65%">
                    <stop offset="0%" stopColor="#ffffff" />
                    <stop offset="22%" stopColor="#fef08a" />
                    <stop offset="55%" stopColor="#ca8a04" />
                    <stop offset="85%" stopColor="#713f12" />
                    <stop offset="100%" stopColor="#422006" />
                </radialGradient>
                {/* Ballon Rouge Rubis 3D */}
                <radialGradient id="bfBalloonRed" cx="35%" cy="28%" r="65%">
                    <stop offset="0%" stopColor="#fecaca" />
                    <stop offset="22%" stopColor="#ef4444" />
                    <stop offset="65%" stopColor="#991b1b" />
                    <stop offset="100%" stopColor="#450a0a" />
                </radialGradient>
            </defs>

            {/* Ficelles dorées */}
            <path d="M75,155 Q85,220 70,295" fill="none" stroke="rgba(234,179,8,0.5)" strokeWidth="1.2" />
            <path d="M148,142 Q135,215 118,300" fill="none" stroke="rgba(234,179,8,0.55)" strokeWidth="1.2" />
            <path d="M108,218 Q105,275 95,340" fill="none" stroke="rgba(234,179,8,0.45)" strokeWidth="1.2" />
            <path d="M210,275 Q195,335 180,395" fill="none" stroke="rgba(234,179,8,0.45)" strokeWidth="1.2" />

            {/* Ballon 1 : Noir (Haut Gauche de la grappe) */}
            <g transform="translate(72, 96) rotate(-8)">
                <ellipse cx="0" cy="0" rx="38" ry="46" fill="url(#bfBalloonBlack)" />
                <ellipse cx="-12" cy="-16" rx="8" ry="14" fill="rgba(255,255,255,0.22)" transform="rotate(-20 -12 -16)" />
                <polygon points="-4,45 4,45 7,51 -7,51" fill="#1f2937" />
            </g>

            {/* Ballon 2 : Or Métallique (Haut Droite) */}
            <g transform="translate(148, 86) rotate(6)">
                <ellipse cx="0" cy="0" rx="36" ry="44" fill="url(#bfBalloonGold)" />
                <ellipse cx="-11" cy="-15" rx="8" ry="13" fill="rgba(255,255,255,0.45)" transform="rotate(-18 -11 -15)" />
                <polygon points="-4,43 4,43 6,49 -6,49" fill="#a16207" />
            </g>

            {/* Ballon 3 : Rouge Rubis (Centre Bas) */}
            <g transform="translate(106, 162) rotate(-4)">
                <ellipse cx="0" cy="0" rx="35" ry="43" fill="url(#bfBalloonRed)" />
                <ellipse cx="-11" cy="-14" rx="7" ry="12" fill="rgba(255,255,255,0.35)" transform="rotate(-15 -11 -14)" />
                <polygon points="-4,42 4,42 6,48 -6,48" fill="#7f1d1d" />
            </g>

            {/* Ballon 4 : Noir (Bord Droit) */}
            <g transform="translate(198, 220) rotate(-10)">
                <ellipse cx="0" cy="0" rx="36" ry="44" fill="url(#bfBalloonBlack)" />
                <ellipse cx="-11" cy="-15" rx="7" ry="13" fill="rgba(255,255,255,0.2)" transform="rotate(-18 -11 -15)" />
                <polygon points="-4,43 4,43 6,49 -6,49" fill="#111827" />
            </g>

            {/* Ballon 5 : Or (Bord Extrême Droit) */}
            <g transform="translate(240, 265) rotate(8)">
                <ellipse cx="0" cy="0" rx="34" ry="42" fill="url(#bfBalloonGold)" />
                <ellipse cx="-10" cy="-14" rx="7" ry="12" fill="rgba(255,255,255,0.4)" transform="rotate(-15 -10 -14)" />
            </g>
        </svg>
    </div>
);

/**
 * Grappe de ballons 3D en bas à gauche (entre la Sidebar et le contenu)
 */
const BlackFridayBalloonsLeft = () => (
    <div className="bf-balloons-left">
        <svg viewBox="0 0 180 280" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
            <defs>
                <radialGradient id="bfBalloonBlackLeft" cx="35%" cy="30%" r="65%">
                    <stop offset="0%" stopColor="#6b7280" />
                    <stop offset="18%" stopColor="#374151" />
                    <stop offset="55%" stopColor="#111827" />
                    <stop offset="100%" stopColor="#030712" />
                </radialGradient>
                <radialGradient id="bfBalloonGoldLeft" cx="35%" cy="28%" r="65%">
                    <stop offset="0%" stopColor="#ffffff" />
                    <stop offset="22%" stopColor="#fef08a" />
                    <stop offset="55%" stopColor="#ca8a04" />
                    <stop offset="85%" stopColor="#713f12" />
                    <stop offset="100%" stopColor="#422006" />
                </radialGradient>
            </defs>

            {/* Ficelles dorées */}
            <path d="M88,108 Q92,175 82,255" fill="none" stroke="rgba(234,179,8,0.5)" strokeWidth="1.2" />
            <path d="M56,162 Q68,215 74,265" fill="none" stroke="rgba(234,179,8,0.55)" strokeWidth="1.2" />
            <path d="M122,155 Q102,210 88,265" fill="none" stroke="rgba(234,179,8,0.5)" strokeWidth="1.2" />

            {/* Ballon Noir Haut */}
            <g transform="translate(88, 58) rotate(-6)">
                <ellipse cx="0" cy="0" rx="34" ry="42" fill="url(#bfBalloonBlackLeft)" />
                <ellipse cx="-10" cy="-14" rx="7" ry="12" fill="rgba(255,255,255,0.22)" transform="rotate(-18 -10 -14)" />
                <polygon points="-3,41 3,41 5,46 -5,46" fill="#1f2937" />
            </g>

            {/* Ballon Or Gauche */}
            <g transform="translate(54, 114) rotate(-12)">
                <ellipse cx="0" cy="0" rx="33" ry="40" fill="url(#bfBalloonGoldLeft)" />
                <ellipse cx="-10" cy="-13" rx="7" ry="11" fill="rgba(255,255,255,0.45)" transform="rotate(-18 -10 -13)" />
                <polygon points="-3,39 3,39 5,44 -5,44" fill="#a16207" />
            </g>

            {/* Ballon Noir Droite */}
            <g transform="translate(122, 108) rotate(10)">
                <ellipse cx="0" cy="0" rx="34" ry="42" fill="url(#bfBalloonBlackLeft)" />
                <ellipse cx="-10" cy="-14" rx="7" ry="12" fill="rgba(255,255,255,0.22)" transform="rotate(-18 -10 -14)" />
                <polygon points="-3,41 3,41 5,46 -5,46" fill="#1f2937" />
            </g>
        </svg>
    </div>
);

/**
 * Serpentins dorés 3D, confettis et étoiles scintillantes en haut de l'écran
 */
const BlackFridayConfettiHeader = () => (
    <div className="bf-header-confetti-svg">
        <svg viewBox="0 0 1440 240" width="100%" height="100%" preserveAspectRatio="xMidYMin slice" xmlns="http://www.w3.org/2000/svg">
            <defs>
                <linearGradient id="bfRibbonGold" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" stopColor="#fef08a" />
                    <stop offset="40%" stopColor="#eab308" />
                    <stop offset="75%" stopColor="#854d0e" />
                    <stop offset="100%" stopColor="#fde047" />
                </linearGradient>
                <radialGradient id="bfStarFlare" cx="50%" cy="50%" r="50%">
                    <stop offset="0%" stopColor="rgba(255, 255, 255, 1)" />
                    <stop offset="25%" stopColor="rgba(254, 240, 138, 0.85)" />
                    <stop offset="60%" stopColor="rgba(234, 179, 8, 0.25)" />
                    <stop offset="100%" stopColor="rgba(234, 179, 8, 0)" />
                </radialGradient>
            </defs>

            {/* Serpentins dorés torsadés 3D répartis en haut */}
            <g fill="url(#bfRibbonGold)" opacity="0.9">
                {/* Serpentin 1 */}
                <path d="M510,5 C522,22 498,38 512,56 C524,72 500,88 514,104 L524,98 C512,82 534,68 522,50 C508,34 532,18 520,2 Z" />
                {/* Serpentin 2 */}
                <path d="M685,12 C698,28 674,44 688,62 C700,78 676,94 690,110 L700,104 C688,88 710,74 698,56 C684,40 708,24 695,8 Z" />
                {/* Serpentin 3 */}
                <path d="M895,0 C908,18 884,36 898,54 C910,70 886,88 900,105 L910,98 C898,82 920,66 908,48 C894,32 918,14 905,-4 Z" />
                {/* Serpentin 4 */}
                <path d="M1015,28 C1028,44 1004,60 1018,78 C1030,94 1006,110 1020,126 L1029,120 C1017,104 1039,90 1027,72 C1013,56 1037,40 1024,24 Z" />
                {/* Serpentin 5 */}
                <path d="M1380,8 C1392,26 1368,42 1382,60 C1394,76 1370,92 1384,108 L1394,102 C1382,86 1404,72 1392,54 C1378,38 1402,22 1389,4 Z" />
                {/* Serpentin 6 (Gauche) */}
                <path d="M295,18 C306,34 286,48 298,64 L306,58 C296,44 314,30 303,14 Z" />
            </g>

            {/* Confettis dorés flottants */}
            <g fill="url(#bfRibbonGold)" opacity="0.85">
                <polygon points="340,42 350,36 355,44 345,50" />
                <polygon points="445,28 456,22 460,31 449,36" />
                <polygon points="575,68 585,62 589,70 578,76" />
                <polygon points="625,22 634,17 638,25 628,30" />
                <polygon points="760,48 772,42 776,51 764,57" />
                <polygon points="835,25 845,19 849,28 839,33" />
                <polygon points="955,62 966,56 970,64 959,70" />
                <polygon points="1135,34 1146,28 1150,36 1139,42" />
                <polygon points="1245,52 1255,46 1259,54 1249,60" />
                <polygon points="1330,26 1340,20 1344,28 1334,34" />
                <circle cx="395" cy="55" r="2.5" fill="#fef08a" />
                <circle cx="545" cy="35" r="2" fill="#fde047" />
                <circle cx="730" cy="72" r="3" fill="#fef08a" />
                <circle cx="865" cy="58" r="2.5" fill="#eab308" />
                <circle cx="1095" cy="48" r="2.5" fill="#fef08a" />
                <circle cx="1290" cy="38" r="2" fill="#fde047" />
            </g>

            {/* Grands éclats d'étoiles dorées (Lens Flares) */}
            <g transform="translate(1075, 58)">
                <circle cx="0" cy="0" r="28" fill="url(#bfStarFlare)" />
                <path d="M0,-22 L2.5,-2.5 L22,0 L2.5,2.5 L0,22 L-2.5,2.5 L-22,0 L-2.5,-2.5 Z" fill="#fef9c3" />
            </g>
            <g transform="translate(1050, 62) scale(0.65)">
                <circle cx="0" cy="0" r="24" fill="url(#bfStarFlare)" />
                <path d="M0,-18 L2,-2 L18,0 L2,2 L0,18 L-2,2 L-18,0 L-2,-2 Z" fill="#fef08a" />
            </g>
            <g transform="translate(650, 42) scale(0.55)">
                <circle cx="0" cy="0" r="22" fill="url(#bfStarFlare)" />
                <path d="M0,-16 L2,-2 L16,0 L2,2 L0,16 L-2,2 L-16,0 L-2,-2 Z" fill="#fef08a" />
            </g>
        </svg>
    </div>
);

const SeasonalDecorations = () => {
    const { isSeasonalActive, decorationsEnabled, themeMeta } = useSeasonalTheme();

    // Génération statique des positions aléatoires pour éviter les recalculs inutiles
    const snowflakes = useMemo(() => {
        return Array.from({ length: 24 }).map((_, i) => ({
            id: i,
            left: `${(i * 4.1 + Math.random() * 2).toFixed(1)}%`,
            size: `${(0.7 + Math.random() * 0.9).toFixed(2)}rem`,
            duration: `${(8 + Math.random() * 7).toFixed(1)}s`,
            delay: `${(Math.random() * 8).toFixed(1)}s`,
            char: i % 3 === 0 ? '❄' : (i % 3 === 1 ? '❅' : '•')
        }));
    }, []);

    const hearts = useMemo(() => {
        return Array.from({ length: 12 }).map((_, i) => ({
            id: i,
            left: `${(i * 8 + Math.random() * 4).toFixed(1)}%`,
            size: `${(0.8 + Math.random() * 0.8).toFixed(2)}rem`,
            duration: `${(10 + Math.random() * 8).toFixed(1)}s`,
            delay: `${(Math.random() * 7).toFixed(1)}s`,
            char: i % 2 === 0 ? '💖' : '💕'
        }));
    }, []);

    const bats = useMemo(() => {
        return [
            { id: 0, left: '25px', size: '1.1rem', duration: '12s', delay: '0s', char: '🦇' },
            { id: 1, left: '135px', size: '1.25rem', duration: '14s', delay: '3.5s', char: '👻' },
            { id: 2, left: '60px', size: '1rem', duration: '16s', delay: '7s', char: '🦇' },
            { id: 3, left: '165px', size: '1.2rem', duration: '13s', delay: '10.5s', char: '👻' },
            { id: 4, left: '95px', size: '1.15rem', duration: '15s', delay: '14s', char: '🦇' },
        ];
    }, []);

    const petals = useMemo(() => {
        return Array.from({ length: 14 }).map((_, i) => ({
            id: i,
            left: `${(i * 7 + Math.random() * 3).toFixed(1)}%`,
            size: `${(0.8 + Math.random() * 0.6).toFixed(2)}rem`,
            duration: `${(9 + Math.random() * 7).toFixed(1)}s`,
            delay: `${(Math.random() * 6).toFixed(1)}s`,
            char: i % 3 === 0 ? '🌸' : (i % 3 === 1 ? '✨' : '🐣')
        }));
    }, []);

    // Particules dorées scintillantes pour Black Friday
    const goldParticles = useMemo(() => {
        return Array.from({ length: 18 }).map((_, i) => ({
            id: i,
            left: `${(i * 5.5 + 2).toFixed(1)}%`,
            size: `${(0.55 + (i % 4) * 0.22).toFixed(2)}rem`,
            duration: `${(11 + (i % 5) * 2.5).toFixed(1)}s`,
            delay: `${(i * 0.7).toFixed(1)}s`,
            char: i % 3 === 0 ? '✦' : (i % 3 === 1 ? '◆' : '•')
        }));
    }, []);

    if (!isSeasonalActive || !decorationsEnabled || !themeMeta?.decorationType) {
        return null;
    }

    return (
        <>
            {/* Black Friday - Couche d'arrière-plan (sous les cartes semi-vitrées) */}
            {themeMeta.decorationType === 'cyber' && (
                <div className="bf-bg-decorations-layer" aria-hidden="true">
                    <BlackFridayConfettiHeader />
                    <BlackFridayBalloonsRight />
                </div>
            )}

            <div className="seasonal-decorations-layer" aria-hidden="true">
                {/* Noël & Fêtes de fin d'année */}
                {themeMeta.decorationType === 'snow' && snowflakes.map((flake) => (
                    <div
                        key={flake.id}
                        className="seasonal-snowflake"
                        style={{
                            left: flake.left,
                            fontSize: flake.size,
                            animationDuration: `${flake.duration}, 4s`,
                            animationDelay: `${flake.delay}, ${flake.delay}`
                        }}
                    >
                        {flake.char}
                    </div>
                ))}

                {/* Saint-Valentin */}
                {themeMeta.decorationType === 'hearts' && hearts.map((heart) => (
                    <div
                        key={heart.id}
                        className="seasonal-heart"
                        style={{
                            left: heart.left,
                            fontSize: heart.size,
                            animationDuration: heart.duration,
                            animationDelay: heart.delay
                        }}
                    >
                        {heart.char}
                    </div>
                ))}

                {/* Halloween - Flottements légers strictement confinés à la barre latérale (Sidebar) */}
                {themeMeta.decorationType === 'bats' && (
                    <div className="seasonal-sidebar-decorations-layer">
                        {bats.map((bat) => (
                            <div
                                key={bat.id}
                                className="seasonal-sidebar-spooky"
                                style={{
                                    left: bat.left,
                                    fontSize: bat.size,
                                    animationDuration: bat.duration,
                                    animationDelay: bat.delay
                                }}
                            >
                                {bat.char}
                            </div>
                        ))}
                    </div>
                )}

                {/* Pâques & Printemps */}
                {themeMeta.decorationType === 'eggs' && petals.map((petal) => (
                    <div
                        key={petal.id}
                        className="seasonal-snowflake"
                        style={{
                            left: petal.left,
                            fontSize: petal.size,
                            animationDuration: `${petal.duration}, 4s`,
                            animationDelay: `${petal.delay}, ${petal.delay}`
                        }}
                    >
                        {petal.char}
                    </div>
                ))}

                {/* Poisson d'Avril */}
                {themeMeta.decorationType === 'fish' && (
                    <div
                        className="seasonal-fish-swimmer"
                        title="Poisson d'Avril !"
                        onClick={() => {
                            alert("🐟 Plouf ! Joyeux 1er Avril de la part de l'équipe ENOVADENT ! 😄");
                        }}
                    >
                        🐟
                    </div>
                )}

                {/* Black Friday - Couche de premier plan (Cadeaux 3D dans les coins, ballons gauche & poussière d'or) */}
                {themeMeta.decorationType === 'cyber' && (
                    <div className="bf-fg-decorations-layer">
                        <BlackFridayBalloonsLeft />
                        <BlackFridayGiftBox className="bf-gift-bottom-left" />
                        <BlackFridayGiftBox className="bf-gift-bottom-right" flip={true} />
                        {goldParticles.map((p) => (
                            <div
                                key={p.id}
                                className="bf-gold-particle"
                                style={{
                                    left: p.left,
                                    fontSize: p.size,
                                    animationDuration: `${p.duration}, 5s`,
                                    animationDelay: `${p.delay}, ${p.delay}`
                                }}
                            >
                                {p.char}
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </>
    );
};

export default SeasonalDecorations;
